import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import commuterTrafficFee, { CommuterTrafficFeeState } from './commuter-traffic-fees/commuter-traffic-fee.store';
import { Company } from './company.interface';
import { CompanyService } from './company.service';
import { CostCenterState } from './cost-centers/cost-center.store';
import { FulltimeState } from './fulltimes/fulltime.store';
import invoiceGroup, { InvoiceGroupState } from './invoice-groups/invoice-group.store';
import { JointCommitteeState } from './joint-committees/joint-committee.store';
import { PropertyTypeState } from './property-types/property-type.store';
import shift, { ShiftState } from './shifts/shift.store';

const service = new CompanyService();

export interface CompanyState {
   //sub-stores
   commuterTrafficFee?: CommuterTrafficFeeState;
   costCenter?: CostCenterState;
   fulltime?: FulltimeState;
   jointCommittee?: JointCommitteeState;
   shift?: ShiftState;
   invoiceGroupState?: InvoiceGroupState;
   propertyType?: PropertyTypeState;
}

const CompanyStore: Module<CompanyState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getCompanies(context: any, query: any) {
         return await service.getCompanies(query);
      },
      async searchCompanies(context: any, query: LocationQuery) {
         return await service.getCompanyByName(query);
      },
      async getCompany(context: any, payload: { companyId: any; query: LocationQuery }) {
         return await service.getCompany(payload.companyId, payload.query);
      },
      async createCompany(context: any, company: any) {
         return await service.postCompany(company);
      },
      async deleteCompany(context: any, companyId: any) {
         return await service.deleteCompany(companyId);
      },
      async changeCompany(context: any, payload: { companyId: number; company: Company }) {
         return await service.putCompany(payload.companyId, payload.company);
      },
      async patchCompany(context: any, { companyId, patchValues }: any) {
         return await service.patchCompany(companyId, patchValues);
      },
   },
   modules: {
      shift,
      invoiceGroup,
      commuterTrafficFee,
   },
};

export default CompanyStore;
